const MIN_SIDEBAR_WIDTH = 270

export const getSidebarSearchPlaceholder = (
  width: number,
  longPlaceholder: string,
  shortPlaceholder = 'Search...',
) => (width <= MIN_SIDEBAR_WIDTH ? shortPlaceholder : longPlaceholder)
